import { Component, OnInit } from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { Product } from '@spartacus/core';

@Component({
    selector: 'app-uig-porduct-references-tab',
    templateUrl: './uig-porduct-references-tab.component.html',
    styleUrls: ['./uig-porduct-references-tab.component.scss'],
    standalone: false
})
export class UigPorductReferencesTabComponent implements OnInit {

  product$: Observable<Product>;

  constructor(protected currentProductService: CurrentProductService) { }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

}
